<div class="animations-container">
    <router-outlet #o="outlet" />
</div>
<!-- <app-cookie-consent></app-cookie-consent> -->
@if (isBrowser) {
    <app-toast-message />
}